define('MM/Components/ContentSearch/FacetTogglePanel',[
    "jquery",
    "knockout",
    "underscore",
    "score_bootstrap/Utils/UrlHelper",
    "MM/Models/ContentSearch/FacetToggleViewModel"
], function ($, ko, _, urlHelper, FacetToggleViewModel) {
    "use strict";

    var searchLogic = ["and", "or_total_count", "or_incremental_count"];

    function FacetTogglePanel(panelElement, allPreselected, urlParam) {
        var facetPanel = $(panelElement).data('facet');
        if (facetPanel != null) {
            // prevent assigning facet panel twice to the same element.
            return facetPanel;
        }

        var $dataEl = $(".js-facet", panelElement),
            title = $dataEl.data("title"),
            searchLogicType = $dataEl.data("search-logic-type").toLowerCase(),
            preselectedByTitle = allPreselected[title] || "";

        var isPreselectedAsUrlParam = !!(preselectedByTitle instanceof Array ? preselectedByTitle[0] : preselectedByTitle);

        var koCheckedValue = ko.observable(isPreselectedAsUrlParam);

        this.facetViewModel = new FacetToggleViewModel($dataEl, koCheckedValue);

        // need to force the default facet to be included into the query when url doesn't have parameter for the ToggleFacet 
        if (!isPreselectedAsUrlParam) {
            urlHelper.setHashValue(window.location, urlParam, title + ":");
        }

        Object.defineProperties(this, {
            title: { value: title },
            searchLogicType: { value: searchLogic.indexOf(searchLogicType) },
            facets: { get: Array.prototype.slice.bind(this.facetViewModel.getFacets()) },
            asString: {
                get: function () {
                    var selectedFacet = this.facetViewModel.getSelectedFacetForAsString();
                    if (selectedFacet) {
                        return this.title + ":" + selectedFacet.value;
                    } else {
                        return null;
                    }
                }
            }
        });

        this.selectValues = function(selectedValues) {
            var selectedByTitle = selectedValues[title] || "";
            this.facetViewModel.getFacets().forEach(function (facet) {
                var oldValue = facet.selected();
                var newValue = selectedByTitle.indexOf(facet.value) > -1;
                if (oldValue !== newValue) {
                    facet.selected(selectedByTitle.indexOf(facet.value) > -1);
                }
            });
        };

        this.selectedValues = ko.pureComputed(function () {
            return this.facetViewModel.getFacets().filter(function (facet) {
                return facet.selected();
            });
        }, this);

        this.unselectAll = function unselectAll() {
            var selectedValue = this.selectedValues()[0].value;

            // need to wait for completion of the 'Clear All' process regarding other facets and then add again our parameters
            setTimeout(function () {
                urlHelper.setHashValue(window.location, urlParam, title + ":" + selectedValue);
            }, 1000);
        };

        $(panelElement).data('facet', this);
    }

    return FacetTogglePanel;
});
